


























































import { mixins } from "vue-class-component";
import { Component, Prop, Watch } from "vue-property-decorator";
import MyMixin from "@/mixins/datemixin";
import MobileMixin from "@/mixins/mobileMixin";
import ListeSites from "@/components/listeSites.vue";
import { Site } from "@/shared/Site";

@Component({
  components: { ListeSites },
})
export default class ExpandableListeSites extends mixins(MyMixin, MobileMixin) {
  @Prop() public selectedSites!: Site[];
  @Prop({ default: true }) public showSelectAll!: boolean;

  public addSite(site: Site) {
    this.$emit("addSite", site);
  }

  @Watch("selectedSites", { immediate: true })
  public onPropertyChanged(value: any, oldValue: any) {
    // this.mesSites = value;
    // console.log(value[0].nom);
    // console.log(this.mesSites[0].nom)
  }

  public removeSite(site: Site) {
    this.$emit("removeSite", site);
  }

  get sites(): any {
    return this.$store.getters["login/sites"];
  }

  get mesSites(): Site[] {
    if (this.sites.length === 1) {
      return this.sites;
    }

    return this.selectedSites;
  }

  get client(): string {
    return this.$store.getters["getClient"];
  }
}
